/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetReference,
    AIDatasetReferenceFromJSON,
    AIDatasetReferenceFromJSONTyped,
    AIDatasetReferenceToJSON,
    AIModelProgress,
    AIModelProgressFromJSON,
    AIModelProgressFromJSONTyped,
    AIModelProgressToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIModel
 */
export interface AIModel {
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AIModel
     */
    readonly state: number;
    /**
     * 
     * @type {AIModelProgress}
     * @memberof AIModel
     */
    progress: AIModelProgress;
    /**
     * 
     * @type {AIDatasetReference}
     * @memberof AIModel
     */
    dataset: AIDatasetReference;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AIModel
     */
    parameters: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    readonly logPath: string;
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof AIModel
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AIModel
     */
    readonly active: boolean;
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    trainingTaskId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AIModel
     */
    threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof AIModel
     */
    epoch?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    preprocessingTask?: string | null;
}

export function AIModelFromJSON(json: any): AIModel {
    return AIModelFromJSONTyped(json, false);
}

export function AIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': json['state'],
        'progress': AIModelProgressFromJSON(json['progress']),
        'dataset': AIDatasetReferenceFromJSON(json['dataset']),
        'parameters': json['parameters'],
        'logPath': json['log_path'],
        'name': json['name'],
        'createdAt': (new Date(json['created_at'])),
        'active': json['active'],
        'trainingTaskId': !exists(json, 'training_task_id') ? undefined : json['training_task_id'],
        'threshold': !exists(json, 'threshold') ? undefined : json['threshold'],
        'epoch': !exists(json, 'epoch') ? undefined : json['epoch'],
        'preprocessingTask': !exists(json, 'preprocessing_task') ? undefined : json['preprocessing_task'],
    };
}

export function AIModelToJSON(value?: AIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'progress': AIModelProgressToJSON(value.progress),
        'dataset': AIDatasetReferenceToJSON(value.dataset),
        'parameters': value.parameters,
        'name': value.name,
        'training_task_id': value.trainingTaskId,
        'threshold': value.threshold,
        'epoch': value.epoch,
        'preprocessing_task': value.preprocessingTask,
    };
}


